import { createSlice } from '@reduxjs/toolkit';

import { errorPopupToggled } from '../../actions/comboSummaryActions';

// Merges into the existing error rather than replacing it, which is what the old
// `const { type, ...rest } = action` spread did. transfer-list's equivalent replaces; the two
// views genuinely differ here.
const errorSlice = createSlice({
  name: 'error',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(errorPopupToggled, (state, action) => ({ ...state, ...action.payload }));
  },
});

export default errorSlice.reducer;
